import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/compras/liquidacionGastos';
import Buscar from './BuscarFactura';

const ms2p = (state) => {
  return {
    ...state.liqGastos,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Buscar);
